const actionTypeIdentifier = 'B263A466-292C-4826-9010-2D0FB72F29EC';

export const getAddCostAllocation = `GET-ADD-COST-ALLOCATION-${actionTypeIdentifier}`;
export const addCostAllocationDetails = `ADD-COST-ALLOCATION-DETAILS${actionTypeIdentifier}`;
export const updateCircuitCostAllocationItem = `UPDATE-CIRCUIT-COST-ALLOCATION-ITEM${actionTypeIdentifier}`;
export const deleteCostAllocationDetails = `DELETE-COST-ALLOCATION-DETAILS${actionTypeIdentifier}`;
export const getCircuitOrderAddCostAllocation = `GET-CIRCUIT-ORDER-ADD-COST-ALLOCATION${actionTypeIdentifier}`;
export const getBillingAccountCostAllocation = `GET-BILLING-ACCOUNT-COST-ALLOCATION${actionTypeIdentifier}`;
export const getTableCircuitGlCodeList = `GET-TABLE-CIRCUIT-GL-CODE-LIST-${actionTypeIdentifier}`;
export const getTableCircuitCostCenterList = `GET-TABLE-CIRCUIT-COST-CENTER-LIST-${actionTypeIdentifier}`;
export const setTableGLCodeLoading = `SET-TABLE-GL-CODE-LOADING-${actionTypeIdentifier}`;
export const setTableCostCenterLoading = `SET-TABLE-COST-CENTER-LOADING-${actionTypeIdentifier}`;

export const circuitCostAllocationFormModel = {
    Key: 0,
    CostAllocationID: -1,
    GLCodeID: null,
    GLCode: null,
    GLCodeName: null,
    CostCodeID: null,
    CostCode: null,
    CompanyCode: null,
    CostCodePercent: null,
    LastModified: null,
}